import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Cart, ClosingDate } from 'src/app/models/cart';
import { CartService } from 'src/app/services/cart.service';
import { Router } from '@angular/router';
import { AlertComponent } from 'src/app/alert/alert.component';
import { LazyLoaderService } from 'src/app/services/lazy-loader.service';
import { AdminHeaderComponent } from 'src/app/layouts/admin-header/admin-header.component';
import { PaginationInstance } from 'ngx-pagination';
import * as firebase from 'firebase';
import { DetailHargaComponent } from 'src/app/detail-harga/detail-harga.component';
import { ProductService } from 'src/app/services/product.service';
import { formatDate } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-list-cart',
  templateUrl: './list-cart.component.html',
  styleUrls: ['./list-cart.component.css']
})
export class ListCartComponent implements OnInit {
  public carts: Cart[] = [];
  public totalProduct: number;
  public totalPrice: number;
  public sealFee: number = 0;
  public deletedIds = [];
  public closingDate: ClosingDate;
  public alertCheckout: string;
  public isLoadingCart = true;
  hasNetPrice = false;
  netPrice = 0;
  subTotalValue = 0;
  tax = 0;
  listDiscount = [];
  totalDiscount = 0;
  hasUpdateCart = false;
  priceBeforeTax = 0;

  @ViewChild(AdminHeaderComponent) header: AdminHeaderComponent;
  @ViewChild('alertComponent') alertComponent: AlertComponent;
  @ViewChild('detailHargaComponent') detailHargaComponent: DetailHargaComponent;

  constructor(private cartService: CartService,
    private router: Router,
    private productService: ProductService) { }

  loadJQueryScript(): void {
    $(document).ready(function () {
      $('#pilih-semua').click(function () {
        $('.checkbox-cart').prop('checked', $(this).prop('checked'));
      });

      $('.checkbox-cart').click(function () {
        if (!$(this).is(':checked')) {
          $('#pilih-semua').prop('checked', false);
        }
      });

      $('.checkbox-cart').click(function () {
        if ($('.checkbox-cart:checked').length === $('.checkbox-cart').length) {
          $('#pilih-semua').prop('checked', true);
        }
      });
    });
  }

  ngOnInit() {
    firebase.analytics().logEvent('keranjang_page');

    this.loadJQueryScript();
    this.loadData();

    $('body').on('keypress', 'input[type=number][maxlength]', function (event) {
      var key = event.keyCode || event.charCode;
      var txtVal = $(this).val();
      var maxlength = $(this).attr('maxlength');
      if (key > 31 && (key < 48 || key > 57)) {
        return false;
      }
      if (txtVal.length == maxlength) {
        event.preventDefault();
        return false;
      }
      return true;
    });

    $('body').on('paste', 'input[type=number][maxlength]', function (event) {
      return false;
    });
  }

  // tslint:disable-next-line: member-ordering
  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  // CR10
  public updateCart() {
    this.hasUpdateCart = true;
    $('#loader').modal('show');

    const products = [];
    this.carts.forEach(element => {
      const item = {
        productCode: element.product_code,
        quantity: element.quantity
      };
      products.push(item);
    });

    const obj = {
      customerCode: JSON.parse(localStorage.getItem('user-profile')).customer_code,
      products
    }

    //CR10
    this.cartService.updateCartPromo(obj,
      data => {
        this.subTotalValue = data.subTotalValue;

        let listPromotions = [];
        data.products.forEach(item => {
          listPromotions.push(item.promotions);
        });

        this.listDiscount = listPromotions.reduce((accumulator, value) => accumulator.concat(value), []);
        this.tax = data.tax;
        this.netPrice = data.netTotalValue;
        this.totalDiscount = data.totalDiscValue;
        this.priceBeforeTax = data.beforeTax;

        for (let i = 0; i < data.products.length; ++i) {
          if (data.products[i] && this.carts[i]) {
            this.carts[i].net_price = data.products[i].netValue;
            this.carts[i].promotions = data.products[i].promotions;
            this.carts[i].productPriceValue = data.products[i].productPriceValue;
            this.carts[i].productPriceNetValue = data.products[i].productPriceNetValue;
            this.totalPrice = data.netTotalValue;
            // $(`#net_price_${this.carts[i].product_code}`).removeClass('d-none');
          }
        }

        if (listPromotions.length > 0) {
          $('#btn-detail-harga').removeClass('d-none');
        }
        $('.cart-price-fixed-top').css('top', '120px');
        this.setUpdateKeranjangProp();
      },
      (err) => {
        if (err.code !== 417) {
          this.alertComponent.show(err.code, err.message);
        }
        setTimeout(() => {
          $('#loader').modal('hide');
        }, 500);
        $('#btn-checkout').addClass('d-none');
        $('#btn-update-keranjang').removeClass('d-none');
        $('#info-promo').show();
      });
  }

  public setUpdateKeranjangProp() {
    setTimeout(() => {
      $('#loader').modal('hide');
    }, 500);
    $('#btn-checkout').removeClass('d-none');
    $('#btn-update-keranjang').addClass('d-none');
    $('#info-promo').hide();
  }

  public resetUpdateKeranjangProp() {
    $('.cart-price-fixed-top').css('top', '180px');
    $('#btn-detail-harga').addClass('d-none');
    $('#btn-checkout').addClass('d-none');
    $('#btn-update-keranjang').removeClass('d-none');
    $('#info-promo').show();

    this.carts.forEach(item => {
      item.promotions = [];
    });
  }

  public loadData(): void {
    this.totalProduct = 0;
    this.totalPrice = 0;
    this.cartService.getCart(
      (data) => {
        this.carts = data;
        this.carts.forEach(item => {
          this.totalPrice += (item.price * item.quantity);
        });

        this.isLoadingCart = false;
        this.getExpireDate();
        this.loadJQueryScript();
      },
      (err) => {
        console.log(err);
      }
    );

    this.cartService.getTotalCart(
      (data) => {
        this.totalProduct = data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  public updateQuantity(type: boolean, cart: Cart): void {
    if (cart === null) {
      return;
    }

    cart.promotions = null;
    // cart.quantity = 1;
    this.totalPrice = 0;
    this.totalProduct = 0;
    this.resetUpdateKeranjangProp();
    this.carts.forEach(item => {
      item.productPriceNetValue = item.productPriceValue ? item.productPriceValue : item.price;
      this.totalProduct += item.quantity;
      this.totalPrice += (item.price * item.quantity);
    });

    if (type) {
      cart.quantity += 1;
      this.totalProduct += 1;
      this.totalPrice += cart.price;
    } else {
      if (cart.quantity > 1) {
        cart.quantity -= 1;
        this.totalPrice -= cart.price;
        this.totalProduct -= 1;
      }
    }

    this.cartService.updateQuantity(cart,
      data => {
      },
      err => {
        if (err.code !== 417) {
          this.alertComponent.show(err.code, err.message);
        }
      });

    this.header.setCarts(this.carts);
  }

  public onChangeQuantity(number: number, cart: Cart): void {
    if (cart === null) {
      return;
    }

    cart.alert_message = null;

    if (number == null || number < 1) {
      cart.alert_message = 'Masukkan jumlah pesanan terlebih dahulu';
    }

    cart.promotions = null;
    this.totalProduct = 0;
    this.totalPrice = 0;
    this.resetUpdateKeranjangProp();

    this.carts.forEach(item => {
      item.productPriceNetValue = item.productPriceValue ? item.productPriceValue : item.price;
      this.totalProduct += item.quantity;
      this.totalPrice += (item.price * item.quantity);
    });

    if (number != null && number > 0) {
      this.cartService.updateQuantity(cart,
        data => {
        },
        err => {
          if (err.code !== 417) {
            this.alertComponent.show(err.code, err.message);
          }
        });
    }

    this.header.setCarts(this.carts);
  }

  // public onChangeQuantity(number: number, cart: Cart): void {
  //   if (cart === null) {
  //     return;
  //   }

  //   cart.promotions = null;
  //   // cart.quantity = 1;
  //   this.totalPrice = 0;
  //   this.totalProduct = 0;
  //   this.resetUpdateKeranjangProp();
  //   this.carts.forEach(item => {
  //     this.totalProduct += item.quantity;
  //     this.totalPrice += (item.price * item.quantity);
  //   });

  //   cart.alert_message = null;

  //   if (number == null || number < 1) {
  //     cart.alert_message = 'Masukkan jumlah pesanan terlebih dahulu';
  //   }

  //   this.totalProduct = 0;
  //   this.totalPrice = 0;

  //   this.carts.forEach(item => {
  //     this.totalProduct += item.quantity;
  //     this.totalPrice += (item.price * item.quantity);
  //   });

  //   if (number != null && number > 0) {
  //     this.cartService.updateQuantity(cart,
  //       data => {
  //       },
  //       err => {
  //         this.alertComponent.show(err.code, err.message);
  //       });
  //   }

  //   this.header.setCarts(this.carts);
  // }

  checkStatusClosing(): void {
    this.cartService.statusClosing(
      data => {
        this.closingDate = data;
        if (this.closingDate.isClosing === false) {
          this.checkout();
        } else {
          $('#statusClose').modal('show');
        }
      },
      err => {
        if (err.code !== 417) {
          this.alertComponent.show(err.code, err.message);
        }
      });
  }

  checkout(): void {
    firebase.analytics().logEvent('order_checkout_button');

    let emptyQuantity = false;

    this.carts.forEach(item => {
      if (item.quantity == null || item.quantity < 1) {
        emptyQuantity = true;

        item.alert_message = 'Masukkan jumlah pesanan terlebih dahulu';
      }
    });

    // if (this.totalPrice < 200000) {
    //   this.alertCheckout = 'Nilai total gross kurang dari 200.000';
    // }

    if (emptyQuantity === false) {
      this.cartService.putToCart(this.carts,
        data => {
          //this.router.navigate(['/checkout']);
          $('#loader').modal('show');
          this.getCheckoutPreview();
        },
        err => {
          if (err.code !== 417) {
            this.alertComponent.show(err.code, err.message);
          }
        });
    }
  }

  getCheckoutPreview(): void {
    this.cartService.checkoutPreview(
      (data) => {
        $('#loader').modal('hide');
        this.router.navigate(['/checkout']);
      },
      (err) => {
        $('#loader').modal('hide');
        if (err.code !== 417) {
          this.alertComponent.show(err.code, err.message);
        }
      }
    );
  }

  delete(): void {
    this.resetUpdateKeranjangProp();

    firebase.analytics().logEvent('keranjang_hapus_barang_button');

    const that = this;
    $.each($('input[type=checkbox]:checked'), function () {
      that.deletedIds.push($(this).val());
    });

    if (this.deletedIds.length > 0) {
      const ids = this.deletedIds.filter(x => x !== 'on');
      this.cartService.delete(ids,
        data => {
          this.alertComponent.show('Berhasil', 'Produk berhasil dihapus dari keranjang');
          const that = this;
          this.carts = this.carts.filter(function (item) {
            return !that.deletedIds.includes(item.id);
          });
          this.deletedIds = [];
          this.header.setCarts(this.carts);

          this.totalProduct = 0;
          this.totalPrice = 0;

          // if (this.hasUpdateCart) {
          //   this.updateCart();
          // } else {
          //   this.carts.forEach(item => {
          //     this.totalProduct += item.quantity;
          //     this.totalPrice += (item.price * item.quantity);
          //   });
          // }

          this.carts.forEach(item => {
            item.productPriceNetValue = item.productPriceValue ? item.productPriceValue : item.price;
            this.totalProduct += item.quantity;
            this.totalPrice += (item.price * item.quantity);
          });
        },
        err => {
          if (err.code !== 417) {
            this.alertComponent.show(err.code, err.message);
          }
        });
      $('.checkbox-cart').prop('checked', false);
    } else {
      this.alertComponent.show('Alert', 'Tidak ada produk yang dipilih');
    }
  }

  detailHarga() {
    this.detailHargaComponent.show(this.subTotalValue, this.totalDiscount, this.listDiscount, this.tax, this.netPrice, this.priceBeforeTax);
  }

  // CR-15
  getExpireDate() {
    this.carts = this.carts.map(function (el) {
      const key = Object.assign({}, el);
      key.expiry_date = '';
      return key;
    });

    let productCode = [];
    this.carts.forEach(element => {
      productCode.push(element.product_code);
    });

    const param = {
      productCode: productCode
    };

    this.productService.getExpireDateProduct(param,
      (data) => {
        const listExpireDate = data;
        listExpireDate.forEach(element => {
          const index = this.carts.findIndex(x => x.product_code === element.productCode);
          if (index !== -1) {
            if (element.bathcEd === '0') {
              element.bathcEd = '-';
            } else {
              element.bathcEd = formatDate(element.bathcEd, 'dd MMMM yyyy', 'id');
            }

            this.carts[index].expiry_date = element.bathcEd;
          }
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }
}
